import './App.css';
import Carta from './Components/Carta/Carta.js'

import React from 'react';

function App() {
  return (
    <div className="App" style={{width: "100%", overflow: "hidden" }}>
        <Carta/>
    </div>
  );
}

export default App;
